import axios from 'axios';
import React,  { useState, useEffect }  from 'react'
import { Helmet } from 'react-helmet';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Card, Main } from '../../Components';
import { login } from '../../Redux/features/authSlice';
import { updateGeneralUI } from '../../Redux/features/uiReducer';
import { ReactComponent as Logo } from './../../assets/logo/logo.svg'
import moment from 'moment'

export function MagicLoginVerification() {

	
	const { confirmation_token } = useParams()
	const navigate = useNavigate()
	
	const [isLoadingSubmit, setIsLoadingSubmit] = useState(false)
	const [response, setResponse] = useState({
		message : "",
		status : "danger"
	})

    const dispatch = useDispatch();

	useEffect(() => {

         

		async function fetch() {
			 
			try{
				
                dispatch(updateGeneralUI({
                    show_sidebar : false
                }))
                const response = await validationProcess();
                 
			}catch(error){
                // console.log(error)
			}
			
		}
		fetch()
	}, [])
	
	
	 

    const validationProcess = () => {

        return new Promise(async(resolve, reject) => {

            setIsLoadingSubmit(true)

            // ! Verify if the magic link token is valid and not expired 
            await axios.post(`${process.env.REACT_APP_API_URL}/users/login/magic-link/:token/verify` , {
                token : confirmation_token
            }, {} )
			.then( res => res.data )
			.then( response => {

				if (typeof response?.token !== 'undefined' && response?.token !== null && moment(response?.expiration).diff(moment() , 'minutes') > 0) {
                        
                    dispatch(login(response));
                    dispatch(updateGeneralUI({
                        show_sidebar : true
                    }))

                    navigate('/pages')
                     
                     

                    setIsLoadingSubmit(false)

                    resolve();
                    


                    
                } else {
                    
                    // toast.error("Something went wrong. Thank you try later.") 
                    setResponse({
                        message : "Invalid or expired magic link.",
                        status : 'danger'
                    });
                    setIsLoadingSubmit(false)
                    reject()
                }
	
			})
			.catch(error => {

				let __error = "Invalid or expired magic link.";
				if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
					navigate('/logout')
				}
				setIsLoadingSubmit(false)
				if (error.response) {
					if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
					
							
					}
					__error = ((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
				} else {
					// Something happened in setting up the request that triggered an Error
					if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
						__error = "Invalid or expired magic link.";
					}
				}

				// toast.error(__error)  
				setResponse({
					message : __error,
					status : 'danger'
				});
				reject(__error)
			})


        });

    }


 


	return (
		<>
			<Helmet>
				<title>Login via magic link - {process.env.REACT_APP_APP_NAME}</title>
			</Helmet>
			<Main size={`full`} withNav={false} positionY="top"  >
				<div className="layout-login-form">
					<div className="logo-wrapper">
						<Logo />
					</div> 
					<Card shadow="md" target="login">
						<form >
							<div className='title'>Login</div>
							{
								isLoadingSubmit === true 
								? 'Login in progress...'
								: (
									response.message !=='' && 
									<p className={`alert alert-${response.status} text-${response.status}`}>{response.message}</p> 
									
								)	
							}
						</form>
					</Card>
                    <div className='under-form'><Link to={`/login`}>Back to login form</Link></div>
				</div>
			</Main>
		</>
	)
}
